<template>
  <jd-dialog
    :title="`${titleText}变更（批量）`"
    :visible.sync="isShow"
    width="450px"
    @close="handleClose"
    @confirm="handleconfirm"
  >
    <el-form :model="physicalBatchShipmentFrom">
      <el-form-item label="上传文件:" required>
        点击<jd-button type="blueText" @click="handleDownloadTemplate"
          >下载模板</jd-button
        >
        <el-upload
          :on-success="handleUpload"
          :show-file-list="false"
          class="upload-demo"
          :drag="true"
          multiple
          with-credentials
          :action="`/jd-hd-web/PointActivityEffectDetails/importGameTaskRecord?activityId=${activityId}`"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        </el-upload>
      </el-form-item>
    </el-form>
    <!-- <div class="downloadMsgBox" v-if="isUpload">
      <div>
        导入成功{{ downloadResData.successNum }}条，导入失败{{
          downloadResData.failNum
        }}条<span v-if="downloadResData.failNum > 0"
          >,导入失败相关用户PIN：</span
        >
      </div>
      <div class="downloadUser" v-if="downloadUserList.length > 0">
        <div
          class="downloaditem"
          v-for="(item, index) in downloadUserList"
          :key="index"
        >
          {{ index + 1 + ". " }}{{ item }}
        </div>
      </div>
    </div> -->
  </jd-dialog>
</template>

<script>
export default {
  props: {
    activityId: {
      type: String,
      default: "",
    },
    titleText: {
      type: String,
      default: "抽奖",
    },
  },
  data() {
    return {
      isShow: true,
      isUpload: false,
    };
  },
  methods: {
    // 下载模板
    handleDownloadTemplate() {
      let url =
        "https://cdn-image.yucrm.cn/template/%E6%AC%A1%E6%95%B0%E5%8F%98%E6%9B%B4%E6%A8%A1%E6%9D%BF.xlsx";
      let elem = document.createElement("a");
      elem.style.display = "none";
      elem.href = url;
      document.body.appendChild(elem);
      elem.click();
      document.body.removeChild(elem);
    },
    handleUpload(res) {
      // 上传文件
      this.isUpload = true;
      if (res.code == 0) {
        this.$message.error(res.message);
      } else if (res.code == 1) {
        this.$message.success(res.message);
      } else {
        this.$message.error(res.message);
      }
    },
    handleClose() {
      if(this.isUpload) {
        this.$emit("close", true);
      } else {
        this.$emit("close", false);
      }
    },
    handleconfirm() {
      if (!this.isUpload) {
        this.$message.warning("请上传文件");
        return;
      }
      this.$emit("close", true);
    },
  },
};
</script>

<style lang="scss" scoped>
.upload-demo {
  margin-top: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  /deep/ .el-upload .el-upload-dragger {
    width: 400px;
  }
}
.downloadMsgBox {
  margin: 20px auto;
  width: 100%;
  line-height: 0;
  .downloadUser {
    margin-top: 12px;
    line-height: 20px;
    margin-left: 16px;
  }
}
</style>
